import DataLabelValueComponent from "../../../components/data-label-value/DataLabelValueComponent";
import {CommonService} from "../../../helpers";
import React from "react";

interface PermanentCardComponentProps{
    jobDetails?:any;
}
const PermanentCardComponent=(props:PermanentCardComponentProps)=>{
    const {jobDetails}=props;
    return (
        <div className={'d-flex'}>
            <DataLabelValueComponent label={'Start Date'} className={'flex-equal'}>
                {jobDetails?.job_start_date ? CommonService.formattedDate(jobDetails?.job_start_date) : 'ASAP'}
            </DataLabelValueComponent>
            {Boolean(jobDetails?.job_end_date) && (
                <DataLabelValueComponent label={'End Date'} className={'flex-equal'}>
                    {CommonService.formattedDate(jobDetails.job_end_date)}
                </DataLabelValueComponent>
            )}
            <DataLabelValueComponent label={'Shift Time'} className={'flex-equal'}>
                {jobDetails?.shift_type ? CommonService.formatTitleCase(jobDetails?.shift_type) : 'AM'}
            </DataLabelValueComponent>
        </div>
    )
}
export default PermanentCardComponent
